module.exports = __webpack_public_path__ + "static/media/crockery.32d254af.svg";